module.exports = __webpack_public_path__ + "img/close-x.9cc34baa.svg";